import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
import resize from '../resize';
Swiper.use([Pagination, Navigation, Lazy]);

const initParticipationSlider = () => {
  const sliderContainer = document.querySelector('.participation__slider');
  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(sliderContainer, {
        loop: true,
        lazy: true,
        effect: 'slide',
        breakpoints: {
          1170: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        },
        navigation: {
          nextEl: '.participation .slider-navigation__button--next',
          prevEl: '.participation .slider-navigation__button--prev',
        },
        pagination: {
          el: '.participation .swiper-pagination',
          type: 'fraction',
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Переход на предыдущий слайд',
          nextSlideMessage: 'Переход на следующий слайд',
        },
      })
    }
  };

  function destroy() {
     if (swiper) {
        swiper.destroy();
        swiper = null;
     }
  }

  function resizeSwiper() {
     window.innerWidth > 767
        ? init()
        : destroy()
  }
  
  sliderContainer && resizeSwiper();
  sliderContainer && resize(resizeSwiper);
};

export default initParticipationSlider;
